<script setup lang="ts">
import Photo1 from '@/components/HomePhotoBlock/assets/photo-1.webp'
import Photo2 from '@/components/HomePhotoBlock/assets/photo-2.webp'
import Photo3 from '@/components/HomePhotoBlock/assets/photo-3.webp'
import Photo4 from '@/components/HomePhotoBlock/assets/photo-4.webp'
import Photo5 from '@/components/HomePhotoBlock/assets/photo-5.webp'
import Photo6 from '@/components/HomePhotoBlock/assets/photo-6.webp'

import { useResponsive } from '@shared/nuxt/useResponsive'

const { isDesktop } = useResponsive()

const listPhotoColumn1 = [Photo1, Photo2, Photo3]
const listPhotoColumn2 = [Photo4, Photo5, Photo6]

const carouselPhotos = [...listPhotoColumn1, ...listPhotoColumn2]
</script>

<template>
  <div id="photoBlock" class="photo-block">
    <h2 class="photo-block__title">Фото</h2>

    <div v-if="isDesktop" class="photo-block__photos-container">
      <div class="photo-block__photos-column photo-block__photos-column--1">
        <nuxt-img
          v-for="(photo, index) in listPhotoColumn1"
          :key="`column_1_${index}`"
          class="photo-block__photo"
          alt="Фото"
          :src="photo"
          width="582"
          height="331"
        />
      </div>

      <div class="photo-block__photos-column photo-block__photos-column--2">
        <nuxt-img
          v-for="(photo, index) in listPhotoColumn2"
          :key="`column_2_${index}`"
          class="photo-block__photo"
          alt="Фото"
          :src="photo"
          width="582"
          height="331"
        />
      </div>
    </div>

    <the-slider
      v-else
      is-different-width
      :space-between="10"
      :slide-width="300"
      :arrows-offset="-20"
      class="photo-block__carousel"
    >
      <nuxt-img
        v-for="(photo, index) in carouselPhotos"
        :key="index"
        class="photo-block__carousel-photo"
        :src="photo"
        alt="Фото"
      />
    </the-slider>

    <div class="photo-block__link-text">
      Больше фото в нашей группе
      <a href="https://vk.com/farfordostavka" class="photo-block__link">
        Вконтакте
      </a>
    </div>
  </div>
</template>

<style scoped lang="scss">
.photo-block {
  padding: 0 20px 120px 20px;

  @include media($bp-tablet) {
    padding: 0 48px 120px 48px;
  }

  @include media($bp-desktop-mini) {
    padding: 0 0 120px;
  }

  &__title {
    margin-bottom: 40px;
    font-size: 30px;
    font-weight: 800;
    color: var(--ui-color-white);

    @include media($bp-desktop-mini) {
      font-size: 40px;
    }
  }

  &__photos-container {
    display: flex;
    gap: 36px;
  }

  &__photos-column {
    display: flex;
    flex-direction: column;
    gap: 40px;

    &--1 {
      padding-bottom: 50px;
    }

    &--2 {
      padding-top: 50px;
    }
  }

  &__photo {
    object-fit: cover;
    border-radius: 20px;

    @include media($bp-desktop-mini) {
      width: 482px;
      height: 274px;
    }

    @include media($bp-desktop) {
      width: 582px;
      height: 331px;
    }
  }

  &__link-text {
    margin-top: 14px;
    font-size: 20px;
    font-weight: 400;
    color: var(--ui-color-white);

    @include media($bp-desktop-mini) {
      width: 50%;
      padding-left: 18px;
      margin-top: 40px;
      margin-left: auto;
    }
  }

  &__link {
    font-weight: 800;
    text-decoration: underline;
  }

  &__carousel {
    margin-bottom: 56px;

    :deep(.app-slider__track) {
      border-radius: 20px;
    }
  }

  &__carousel-photo {
    width: 100%;
    height: 200px;
    object-fit: fill;

    @include media($bp-tablet) {
      width: 100%;
      height: 400px;
      object-fit: contain;
    }
  }
}
</style>
